<template>
  <div style="background:#F4F5F9" class="my_approval">
    <header-bar :rightPart="true" @backTo="backTo"></header-bar>
    <!-- 标题 -->
    <div class="list-block">
      <div class="list_block_title">
        <div class="title-box1">
          <span class="titleStyle">提案</span>
          <span class="nameStyle">{{title}}</span>
        </div>
      </div>
      <div class="list_block_ctn">
        <div class="conterStyle" v-html="content"></div>
      </div>
      <div class="title-box1">
        <div class="myConterClass">
          <span class="title_third">提案作者</span>
          <span class="ctn_third">{{proposer}}</span>
        </div>
        <div class="myConterClass">
          <span class="title_third">职务</span>
          <span class="ctn_third">{{post}}</span>
        </div>
      </div>
      <div class="title-box1">
        <div class="myConterClass">
          <span class="title_third">分会</span>
          <span class="ctn_third">{{branch}}</span>
        </div>
        <div class="myConterClass">
          <span class="title_third">科室</span>
          <span class="ctn_third">{{department}}</span>
        </div>
      </div>
      <div class="dealine_date">提交日期：{{time}}</div>
    </div>
    <!-- 标题结束 -->
    <div>
      <div class="proposal_ctn">
        <div class="title_second">
          <span></span>提案内容
        </div>
        <div>
          <div class="title_third">案由</div>
          <div class="ctn_third">{{causeOfAction}}</div>
        </div>
        <div>
          <div class="title_third">案据</div>
          <div class="ctn_third">{{accordingToInformation}}</div>
        </div>
        <div>
          <div class="title_third">方案</div>
          <div class="ctn_third">{{programme}}</div>
        </div>
      </div>
      <div class="proposal_title_32">
        <div>附议代表（{{num}}人)</div>
      </div>

      <div
        v-for="(item,index) in arr"
        :key="index"
        :class="item.statusp != '1'?'sign_list':'sign_list sign_height'"
      >
        <div class="sign_title">签名</div>
        <div class="photoStyle">
          <img :src="item.signatrue" />
        </div>
      </div>
      <!-- 审核信息 -->
      <div class="proposal_ctn">
        <div class="title_second">
          <span></span>审核信息
          <p class="apply-p1">{{titleToExamine}}</p>
        </div>
      </div>
      <!-- 审核详情 -->
      <!-- 审核详情 -->
      <div class="steps-div-box">
        <van-steps direction="vertical" :active="timeActive" active-color="#29BEBC">
          <van-step v-for="(item,index) in approvalList" :key="index">
            <div class="step-box1">
              <div class="applyImg"></div>
              <span
                :class="'applytxt step-text1 ' + transfromStartTitle(item.status,'style')"
              >{{transfromStartTitle(item.status,'title')}}</span>
              <p class="step-time-p">{{item.endTime}}</p>
            </div>
            <div class="steps-span-box">
              <span class="step-item-span">审核节点</span>
              <span class="span-items">{{item.name}}</span>
            </div>
            <div class="steps-span-box">
              <span class="step-item-span">审核人</span>
              <span class="span-items">{{item.userName}}</span>
            </div>
            <div class="steps-span-box">
              <span class="step-item-span">审核意见</span>
              <span class="span-items">{{item.idea}}</span>
            </div>
          </van-step>
        </van-steps>
      </div>
      <!-- 审核详情结束 -->

      <div v-if="multipleRowObj.status==1">
        <div class="proposal_ctn">
          <div class="title_second">
            <span></span>提案委员会审核意见
          </div>
          <div class="radio-item-box">
            <van-radio-group v-model="opinion" direction="horizontal" icon-size="23">
              <van-radio name="1" checked-color="#29BEBC">合格提案</van-radio>
              <van-radio name="2" checked-color="#29BEBC">按建议处理</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div class="ctn_all">
          <!-- 审核批注 -->
          <div class="info-box2">
            <p class="textArea-span-title">审核备注</p>
            <van-field
              v-model="textarea"
              rows="3"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="请输入内容，字数在200字以内。"
              show-word-limit
              :clearable="true"
            />
          </div>
          <!-- 审核批注结束 -->
          <div class="my_flex_ctn">
            <span>办理部门</span>
            <div @click="deptShowFn">
              <div class="peopleShowBox">
                <div v-for="item in depentName" :key="item.id">{{item.name}}
                   <span>、</span>
                </div>
              </div>
              
              <van-icon name="arrow" class="right-icon" />
            </div>
          </div>
          <div class="my_flex_ctn">
            <span>阅示主管</span>
            <div @click="peopleShowFn">
              <div class="peopleShowBox">
                 <div v-for="(peopleName,index) in result" :key="index">{{peopleName.name}}
                   <span>、</span>
                 </div>
              </div>
              <van-icon name="arrow" class="right-icon" />
            </div>
          </div>
        </div>
        <button class="submit_btn" @click="submit">提交</button>
      </div>
      <div v-else>
        <div class="proposal_ctn">
          <div class="title_second">
            <span></span>提案委员会审核意见
          </div>
          <div class="text_second">
            <div>为合格提案</div>
            <div>
              交由
              <span>{{dealDeptName}}</span>办理，请
              <span>{{dealStaffName}}</span>（主管领导）阅示
            </div>
          </div>
        </div>
      </div>

      <!-- 详情结束 -->
    </div>
    <!-- 逻辑操作结束 -->
    <!-- 选择人员弹框 -->
    <van-popup
      :lock-scroll="true"
      v-model="peopleShow"
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <!-- <van-picker
        title="选择人员"
        show-toolbar
        :columns="nameObj"
        @confirm="peopleConfirm"
        @cancel="peopleCancel"
      /> -->
  
      <VanCheckboxGroup v-model="result">
        <van-checkbox v-for="item in nameObj" :key="item.id" :name="item">{{item.name}}</van-checkbox>
      </VanCheckboxGroup>
       <div class="confirmBtn" @click="selectPeople">确定</div>
    </van-popup>
    <!-- 选择人员弹框 结束 -->
  </div>
</template>
<script>

import topPart from "../../../components/topPart";
import moment from "moment";
import { toast } from "@/common/api/api.js";
import signature from "../../../components/signature.vue";
import headerBar from "../../../components/headerBar";

export default {
  components: {
    topPart,
    signature,
    headerBar,

  },
  data() {
    return {
      getIdentity: {
        1: "工会员工",
        2: "分会组长",
        3: "分会管理",
        4: "工会管理",
        5: "系统管理员",
      }, //身份标识
      proposer: "", //提案作者
      post: "", //职位
      branch: "", //分会
      department: "", //部门
      dealDeptName: "", //科室名称
      dealStaffName: "", //人员名称
      depentId: [], //科室ID
      depentName: [],
      depentOpention: [], //科室列表
      depentObj: [], //科室对象
      nameId: [], //人员id
      result:[], //人员名称
      nameOpention: [], //人员列表
      nameObj: [], //人员对象
      peopleName: "",
      peopleShow: false,
      titleToExamine: "", //内容
      timeActive: "-1", //时间轴默认显示的数据条数
      multipleRowObj: {},
      textarea: "", //建议内容
      opinion: "1", //审核意见
      num: 0,
      sign: this.$route.query.sign,
      arr: [], //签名列表
      accordingToInformation: "", //案据
      programme: "", //方案
      causeOfAction: "", //案由
      id: this.$route.query.row,
      time: "",
      title: "",
      approvalList: [],
      content: "",
      items:[],
     
      value2:[],
      depentNames:[]
    };
  },
  activated() {
    this.getMultipleRow(this.id);
    let chosedDept = JSON.parse(sessionStorage.getItem("chosedDept"));
    if (chosedDept) {
      chosedDept.forEach((item,index)=>{
        this.depentName.push(item);
        this.depentId.push(item.id);
      })
      let d = []
      let hash = {}
      d = this.depentName.reduce((item, next) => {
        hash[next.id] ? '' : hash[next.id] = true && item.push(next)
        return item
      }, [])
      this.depentName = [...d]
      // this.depentName = chosedDept.name;
      // this.depentId = chosedDept.id;
    } else {
      this.getStartConfig();
      this.getQueryHistoricActivitiInstancebyPlanid(this.id);
      //获取详细信息
      this.getTaOneData(this.id);
      //获取科室 和人员
      this.chairmanData();
    }
  },
  mounted() {
    this.getMultipleRow(this.id);
    this.getStartConfig();
    this.getQueryHistoricActivitiInstancebyPlanid(this.id);
    //获取详细信息
    this.getTaOneData(this.id);
    //获取科室 和人员
    this.chairmanData();
  },
  //  beforeRouteLeave(to, from, next) {
  //   this.id = ''
  //   next();
  // },
  methods: {
    getMultipleRowData(orderNumber) {
      var obj = {
        nowPage: 1, //当前页数
        pageSize: 10, //每页展示多少个
        planId: orderNumber, //订单ID
        sendType: "enquiryAgent", //查询我的审批
      };
      return obj;
    },
    getMultipleRow(orderNumber) {
      var obj = this.getMultipleRowData(orderNumber);
      this.centralControl.axios.centralControl(
        "enquiryAgent",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            if (data.list) {
              for (var a = 0; a < data.list.length; a++) {
                if (data.list[a].status == "1" || data.list[a].status == "2") {
                  this.multipleRowObj = data.list[a];
                  // this.status = this.multipleRowObj.status;
                  return;
                }
              }
              // this.status = this.multipleRowObj.status;
              this.multipleRowObj = data.list[0];
            }
          }
        },
        obj
      );
    },
    // 返回
    backTo() {
      this.$router.go(-1);
      sessionStorage.removeItem("chosedDept");
    },
    /* 选择科室弹框 */
    deptShowFn() {
      this.$router.push({
        path: "/choseDept",
        query: {
          id: this.depentId,
          // id: this.depentName,
        },
      });
    },
    selectPeople(){
      this.result.forEach((v,i)=>{
        this.nameId.push(v.id)
      })
      this.peopleShow = false
    },
    /* 选择人员弹框 */
    peopleShowFn() {
      this.peopleShow = true;
    },

    // peopleConfirm(value, index) {
    //   this.peopleShow = false;
    //   this.peopleName = value;
    //   this.nameId = this.nameOpention[index].id;
    // },
    // peopleCancel() {
    //   this.peopleShow = false;
    // },
    /* 选择人员弹框 */

    getStartConfig() {
      this.startConfig = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy", "approveStartEnglish"]
      );
      //获取慰问配置
      var obj = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy"]
      );
      this.startConfig = obj.approveStartEnglish; //获取配置对象
      this.approveStartEnglishTitle = obj.approveStartEnglishTitle; //获取标题配置对象
    },
    //审核标题转换
    transfromStartTitle(status, title) {
      return this.approveStartEnglishTitle[status][title];
    },
    //获取审批数据
    getQueryHistoricActivitiInstancebyPlanid(orderNumber) {
      var obj = {
        planid: this.id,
      };

      this.centralControl.axios.centralControl(
        "queryHistoricActivitiInstancebyPlanid",
        (res) => {
          const { data, code, message } = res;
          if (code == 200) {
            this.transfromData(data);
          }
        },
        obj
      );
    },
    //格式化时间
    dateFormat(str) {
      if (new Date(str)) {
        return new Date(str).format("yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    //转换数据函数
    transfromData(orderList) {
      var copy = [];
      for (var a = 0; a < orderList.length; a++) {
        var obj = {
          endTime:
            orderList[a].endTime == null || orderList[a].endTime == ""
              ? ""
              : this.dateFormat(orderList[a].endTime),
          userName: orderList[a].userName,
          name: orderList[a].name,
          status: orderList[a].status,
          idea: orderList[a].idea,
        };
        copy.push(obj);
        if (obj.status == "audit") {
          this.timeActive = a;
          this.titleToExamine = `正在等待${obj.userName}审核!`;
        }
      }
      this.approvalList = copy;
    },
    getTaOneDataFun(data) {
      this.dealDeptName = []
      this.dealStaffName = []
      this.proposer = data.staffInfo.name; //作者名称
      this.post = this.getIdentity[data.staffInfo.identity]; //职务
      this.branch = data.staffInfo.unionName; //分会unionName
      this.department = data.staffInfo.deptName; //科室
      this.dealDeptName = data.record.dealDeptName;
      this.dealStaffName = data.record.dealStaffName;
      this.time = moment(data.record.subTime).format("YYYY-MM-DD HH:mm:ss"); //提交日期
      this.title = data.proposal.title; //名称
      this.content = data.proposal.content; //富文本
      this.arr = data.signatures; //赋值签名图片
      this.num = data.proposal.auditNum; //附议人数
      this.causeOfAction = data.record.reason;
      this.accordingToInformation = data.record.evidence;
      this.programme = data.record.proposal;
      // this.dealDeptName = data.record.dealDeptName.split(',');
      // this.dealStaffName = data.record.dealStaffName.split(',');
    },
    //获取详情数据
    getTaOneData(planId) {
      var idStr = planId.replace("TA", "");
      var obj = {
        id: idStr,
      };
      this.democraticFlag = true;
      this.centralControl.axios.centralControl(
        "proposalAndSignatureDetail",
        (res) => {
          const { code, data, message } = res;
          this.getTaOneDataFun(data);
        },
        obj
      );
    },
    //获取数据
    chairmanData() {
      var that = this;
      this.centralControl.axios.centralControl(
        "findLeaderAndDeptList",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            //赋值科室
            that.result = []
            that.depentName = []
            that.depentId = []
            that.nameId = []
            that.depentOpention = data.officeList;
            let chosedDept = JSON.parse(sessionStorage.getItem("chosedDept"));
            if (!chosedDept) {
              // that.depentId = data.officeList[0].id;
              // that.depentName = data.officeList[0].name;
              that.depentId.push(data.officeList[0].id);
              that.depentName.push(data.officeList[0]);
            }

            //赋值主席
            that.nameOpention = data.leaderStaff;
            let arr2 = [];
            data.leaderStaff.forEach((item) => {
              arr2.push(item);
            });
            this.nameObj = arr2;
            that.result.push(data.leaderStaff[0])
            that.nameId.push(data.leaderStaff[0].id);
            // that.nameId = data.leaderStaff[0].id;
            // that.peopleName = data.leaderStaff[0].name;
          }
        },
        {}
      );
    },
    submitFun(data, message) {
      toast(this, message, "success");
      setTimeout(() => {
        this.$destroy(true);
        this.$router.go(-1);
      }, 2000);
    },
    getSubmitData() {
      let newNameId = []  //去重
      this.nameId.forEach((m,n)=>{
        if(newNameId.indexOf(m) == -1){
            newNameId.push(m)
        }
      })
      var obj = {
        democraticDept: this.depentId?this.depentId.join(','):'', //申请科室
        democraticNameId: newNameId?newNameId.join(','):'', //选中人员
        comfortType: "6", //保存类型
        approvedAmount: "", //保存金额
        opinion: this.textarea,
        type: this.opinion,
        planid: this.multipleRowObj.planId,
        taskId: this.multipleRowObj.id,
        taskName: this.multipleRowObj.name,
        userName: this.multipleRowObj.startUserName,
        userId: this.multipleRowObj.startUserId,
      };
      return obj;
    },
    //提交函数
    submit(data, message) {
      var obj = this.getSubmitData();
      this.sendQuestion("approval", obj, "submitFun");
    },

    //获取详情参数
    getgetDetailsData() {
      var obj = {
        id: this.recordId,
        proposalId: this.id,
      };
      return obj;
    },
    //赋值 提案数据
    objTransfrom(obj, item) {
      this.programme = obj.proposal; //方案
      this.causeOfAction = obj.reason; //案由
      this.accordingToInformation = obj.evidence; //案据
      this.num = item.auditNum; //附议人数
    },
    //处理返回数据
    getDetailsFun(data, message) {
      this.arr = data.signatures; //签名列表
      //策略转换数据
      this.title = data.proposal.title; //赋值title
      this.content = data.proposal.content; //赋值内容content
      this.time = moment(data.proposal.endTime).format("YYYY-MM-DD HH:mm:ss"); //结束时间
      //提交按钮转换
      this.statusTransfrpm();
      //内容转换
      this.objTransfrom(data.record, data.proposal);
    },
    //获取详情数据
    getDetails() {
      var obj = this.getgetDetailsgetDetailsData();
      this.sendQuestion("proposalAndSignatureDetail", obj, "getDetailsFun");
    },
    //后端发送请求函数
    sendQuestion(url, obj, fun) {
      this.centralControl.axios.centralControl(
        url,
        (res) => {
          const { message, code, data } = res;
          //请求返回 关闭加载页
          this.loading = false;
          if (code == 200) {
            this[fun](data, message);
          } else {
            console.log(res, "接口错误-");
          }
        },
        obj
      );
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/common.styl';
@import '../../../assets/stylus/theme.styl';

.myConterClass {
  width: 45%;
  padding: 16px;
}

.list_block_ctn_conter {
  margin-left: 10px;
  font-size: 12px;
}
/deep/ .van-checkbox{
  height:40px;
  line-height:40px;
  text-align:center;
  border-bottom:1px solid #eee;

}
/deep/ .van-checkbox-group{
  padding:10px 20px;

}
/deep/ .van-checkbox__icon--checked .van-icon{
  background-color:#29BDBB !important;
  border-color:#29BDBB !important;
}
.van-checkbox__label{
  color:#29BDBB !important;
}
.peopleShowBox{
   display:flex;
   align-items:center;
   width:210px;
   overflow: hidden; /* 超出部分隐藏 */
    white-space: nowrap; /* 不换行 */
    text-overflow: ellipsis; /* 超出部分文字以...显示 */
    word-break:break-all;
    >div{
      margin-right:5px;
    }
}

.my_approval {
  .van-popup {
    overflow-y: auto;
  }

  >>> .van-picker__confirm {
    color: #29BDBB !important;
  }
}

.ctn_all {
  background: #FFF;
}

.my_flex_ctn {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  border-bottom: 1px solid #EFEFF4;

  span {
    flex: 1;
  }

  >div {
    flex: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #888888;
  }

  >>> .van-dropdown-menu {
    margin: 0 10px;
  }
}
.confirmBtn{
    width:115px;
    height:40px;
    background:#29BEBC;
    color:#fff;
    text-align center;
    line-height:40px;
    position:fixed;
    bottom:5px;
    left:35%;
    border-radius:20px;
  }

.title-box1 {
  display: flex;
  align-items: baseline;
}

.name-title-box {
  padding: 15px 15px 12px;
  border-bottom: 1px solid #EFEFF4;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.span-items {
  color: $text-gray;
  flex: 1;
  word-break:break-all;
}

.apply-p1 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 75, 75, 1);
  margin-left: 10px;
}

.applyImg {
  width: 7px;
  height: 7px;
  background-color: $main-bgColor;
}

.step-item-span {
  width: 80px;
}

.step-box1 {
  flexDiv();
  background: rgba(244, 245, 249, 1);
  border-radius: 30px;
  padding: 10px 10px;
}

.textArea-span-title {
  margin: 10px 0 5px;
  line-height: 24px;
}

.enclosureConter {
  flex: 1;
  min-width: 0;

  >div {
    line-height: 34px;
    border-bottom: 1px solid #EFEFF3;
  }

  >div:nth-last-child(1) {
    border: none;
  }

  a {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(86, 137, 240, 1);
  }
}

.box_left {
  line-height: 30px;
}

.enclosureBox {
  display: flex;
  align-items: center;
}

.enclosureTitle {
}

.qbz-icon {
  width: 14px;
  height: 15px;
  margin-right: 5px;
}

.photoStyle {
  width: 44px;
  height: 130px;
  transform: rotate(90deg);
  transform-origin: 62px 56px;
  margin-left: 40px;

  img {
    width: 100%;
    height: 100%;
  }
}

.titleStyle {
  padding: 4px 7px;
  border-radius: 20px;
  font-size: 11px;
  background: linear-gradient(103deg, rgba(79, 172, 254, 1), rgba(0, 242, 254, 1));
  color: #fff;
  text-align: center;
  display: inline-block;
  margin: 0 10px 0 0;
  height: fit-content;
}

.list-block-copy {
  display: flex;
  height: 0.5rem;
  align-items: center;
  padding-top: calc(0.3rem);
  background: #FFF;
}

.nameStyle {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
  line-height: 22px;
  width: 70%;
  min-width: 0;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  flex: 1;
}

.list-block {
  background: #FFF;
  margin-top: 50px;
  height: auto !important;

  .list_block_title {
    padding: 16px;
    border-bottom: 1px solid #EFEFF4;
    display: flex;
  }

  .list_block_ctn {
    padding: 10px 16px;
  }
}

.applytxt {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: $text-black;
  margin-left: 5px;
  width: 25%;
}

.conterStyle {
  // padding: 0 10px 10px 10px;
  >>> img {
    max-width: 100%;
    margin-top: 4px;
  }

  >>> p, span {
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }

  >>> p:nth-child(1) {
    margin-top: 0;
    word-break:break-all;
  }

  >>> ol, span, ol, li, ul, h1, h2, strong, em {
    display: inline-block;
  }

  >>>br {
    display: none;
  }
}

.dealine_date {
  width: 100%;
  height: 36px;
  background: rgba(255, 75, 75, 0.1);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FF4B4B;
  text-align: center;
  line-height: 36px;
}

.info-box2 {
  padding: 0 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}

.suggest_color {
  background: linear-gradient(103deg, rgba(69, 209, 172, 1), rgba(39, 189, 186, 1));
}

.vote_color {
  background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
}

.steps-div-box {
  position: relative;
}

.ctn_third {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(135, 135, 135, 1);
  line-height: 20px;
  max-height: 150px;
  overflow-y: auto;
  margin-left: 10px;
  word-break:break-all;
}

.title_third {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  padding: 18px 0 10px 0;
}

.proposal_ctn {
  padding: 16px;
  background: #FFF;
  margin-top: 10px;

  .text_second {
    font-size: 14px;

    >div {
      line-height: 24px;
    }

    span {
      color: red;
    }
  }

  .step-time-p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: $text-black;
  }

  .title_third {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    padding: 18px 0 10px 0;
  }

  .ctn_third {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(135, 135, 135, 1);
    line-height: 20px;
    max-height: 150px;
    overflow-y: auto;
  }
}

>>> .van-cell {
  padding: 10px;
  background: rgba(243, 245, 249, 1);
  border-radius: 10px;
}

>>> .van-field__word-limit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(135, 135, 135, 1);
}

.submit_btn {
  width: 90%;
  // border: 1px solid rgba(41, 189, 187, 1);
  border-radius: 10px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  height: 44px;
  margin: 20px;
  line-height: 44px;
  background: #38C7C4;
}

.steps-span-box {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
  display: flex;
  margin: 10px auto;
}

.proposal_title_3 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  border-bottom: 1px solid #EFEFF3;
  padding: 20px;
  background: #FFF;
  margin-top: 10px;
}

.proposal_title_32 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  border-bottom: 1px solid #EFEFF3;
  padding: 16px 20px;
  background: #FFF;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(41, 189, 187, 1);
    margin-right: 10px;
  }

  img {
    width: 22px;
  }
}

.my_flex {
  display: flex;
  align-items: center;
  background: #FFF;
  padding: 16px;
  justify-content: space-between;

  .sign_title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }
}

.signature_edit {
  width: 252px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(41, 190, 188, 1);

  .no_singature {
    display: inline-block;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(41, 190, 188, 1);
    line-height: 22px;
  }

  img {
    width: 16px;
    margin-right: 4px;
  }
}

.radio-item-box {
  flex: 1;
  font-size: 14px;
  margin-top: 10px;
}

.sign_list {
  display: flex;
  padding: 26px 16px;
  background: #FFF;
  border-bottom: 1px solid #EFEFF3;

  .sign_title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
  }

  .sign_title_empty {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 75, 75, 1);
    margin-left: 40px;
  }

  >div:nth-child(2) {
    // margin-left: 40px;
  }
}

.sign_height {
  height: 30px;
}

.title_second {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(53, 53, 53, 1);
  position: relative;
  border-bottom: 1px solid #EFEFF3;
  padding-bottom: 16px;

  span {
    display: inline-block;
    width: 7px;
    height: 7px;
    background: #29BDBB;
    margin-right: 4px;
  }
}
</style>